import {
  Button,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
  Tooltip,
} from "@material-tailwind/react";
import { ReactComponent as EditPencil } from "../../Assets/Svg/EditPencil.svg";
import EditSubDebatePopup from "../../Components/Popup/EditSubDebatePopup";
import {
  useDebatesStatusStore,
  useSubworkspaceStore,
  useUserStore,
} from "../../Context/store";
import { useState } from "react";
import { useRolePermissions } from "../../hooks/usePermission";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import AddSubWorkspacePopup from "../../Components/Popup/AddSubWorkspacePopup";

const ForumTitle = () => {
  const { user: loggedInUser } = useUserStore();
  const [toggle, setToggle] = useState();
  const {
    selectedSubWorkspace,
    selectSubWorkspace,
    subWorkspaceList,
  } = useSubworkspaceStore();
  const { allForumStatus, setCurrentForumStatus } = useDebatesStatusStore();
  const [popup, setPopup] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const { hasPermission, getLimit } = useRolePermissions();

  const handleForumSelect = (subWorkspace) => {
    selectSubWorkspace(subWorkspace);
    setCurrentForumStatus(
      allForumStatus?.forums?.[subWorkspace?.subWorkSpaceId]
    );
  };

  const pilotPlanRestriction =
    getLimit(loggedInUser?.role, "maxCreateForumCount") &&
    hasPermission(loggedInUser?.role, "createForum") &&
    subWorkspaceList?.length <
      getLimit(loggedInUser?.role, "maxCreateForumCount");

  if (subWorkspaceList?.length === 0) {
    return null;
  }
  return (
    <div className="flex flex-col justify-center px-4 py-2">
      <p className="text-secondary font-semibold text-lg md:text-debatePalette-background">Selected Forum</p>
      {selectSubWorkspace && (
        <div className="flex justify-between items-center">
          <Menu
            ripple={false}
            placement="bottom-start"
            open={toggle}
            handler={() => setToggle(!toggle)}
          >
            <MenuHandler>
              <div className="flex w-[80%]">
                <Button
                  ripple={false}
                  variant="text"
                  className="flex p-0 gap-2 justify-start w-full items-center font-normal capitalize tracking-normal hover:bg-transparent active:bg-transparent"
                >
                  <span className="flex-1 xs:line-clamp-1 w-full text-sm text-left text-secondary md:text-debatePalette-hr">
                    {selectedSubWorkspace?.subWorkSpaceName}
                  </span>
                  <ChevronDownIcon
                    strokeWidth={2.5}
                    className={`h-3.5 w-3.5 transition-transform mt-1 text-secondary md:text-debatePalette-background ${
                      toggle ? "rotate-180" : ""
                    }`}
                  />
                </Button>
              </div>
            </MenuHandler>
            <Tooltip content="Edit debatebase">
              <EditPencil
                className="h-6 w-6 text-secondary md:text-white cursor-pointer hover:text-debatePalette-buttonBorder"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenPopup(true);
                }}
              />
            </Tooltip>
            <MenuList className="z-10000000" >
              {subWorkspaceList?.map((subWorkspace, index) => (
                <MenuItem
                  className="flex gap-3 p-2 items-center text-debatePalette-title font-medium"
                  key={index}
                  onClick={() => handleForumSelect(subWorkspace)}
                >
                  <span>{subWorkspace?.subWorkSpaceName}</span>
                  {allForumStatus?.forums?.[subWorkspace?.subWorkSpaceId]
                    ?.isNewDebate && (
                    <div className="inline-block size-2 rounded-full bg-primary"></div>
                  )}
                  {/* {<ChevronRightIcon className="h-4 w-4" />} */}
                </MenuItem>
              ))}
              {pilotPlanRestriction ? (
                <MenuItem
                  className="flex gap-3 p-2 text-debatePalette-title font-medium"
                  onClick={() => setPopup(true)}
                >
                  Create Forum {<ChevronRightIcon className="h-4 w-4" />}
                </MenuItem>
              ) : (
                subWorkspaceList?.length === 0 && (
                  <MenuItem
                    disabled={true}
                    className="flex gap-3 p-2 text-debatePalette-title font-medium"
                  >
                    No forum
                  </MenuItem>
                )
              )}
            </MenuList>
          </Menu>
        </div>
      )}
      <EditSubDebatePopup
        open={openPopup}
        handleClose={() => setOpenPopup(false)}
      />
      <AddSubWorkspacePopup
        handleClose={() => setPopup(false)}
        setPopup={setPopup}
        open={popup}
      />
    </div>
  );
};

export default ForumTitle;
